'use strict';

var intellidealerAppMyAccountModule = angular.module('intellidealerApp.myAccount', ['intellidealerApp.core']);

